<template>
    <!-- 平台个人中心 -->
    <div>
      <el-tabs :tab-position="'left'">
        <el-tab-pane label="账号安全">
          <user-central-item @btn-click="$refs.changePwdDialog.show()" :img-src="require('@/assets/password.png')" title="密码" core-value="*****" btn-value="修改密码"/>
          <user-central-item @btn-click="$refs.changePhone.show()" :img-src="require('@/assets/phone.png')" title="手机号"
          :core-value="this.userInfo.phone?this.utils.hidePhone(this.userInfo.phone):'未绑定'" btn-value="修改手机号"/>
        </el-tab-pane>
      </el-tabs>
      <change-pwd-dialog ref="changePwdDialog"/>
      <change-phone ref="changePhone"/>
    </div>
</template>
<script>
import { userCentralItem, changePwdDialog, changePhone } from './components'
export default {
  components: {
    userCentralItem,
    changePwdDialog,
    changePhone
  },
  data() {
    return {
      userInfo: {
        phone: '',
        unionId: ''
      }
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      const phone = JSON.parse(sessionStorage.getItem('userInfo')).phone
      this.userInfo.phone = phone
      console.log(this.userInfo.phone)
    }
  }
}
</script>
<style lang="less" scoped>
.el-tabs{
  margin: 5% 10% 10% 5%;
}

</style>
